import Immutable from 'immutable';
import RecentlyReturnedConstants from '../../constants/RecentlyReturnedConstants';

const {
  FETCH_RETURN_HISTORY_REQUEST,
  FETCH_RETURN_HISTORY_SUCCESS,
  FETCH_RETURN_HISTORY_FAILURE
} = RecentlyReturnedConstants;

const initialState = Immutable.fromJS({
  results: [],
  isFetching: false
});

export default function borrowingHistory(state = initialState, action) {
  switch (action.type) {
    case FETCH_RETURN_HISTORY_SUCCESS:
    case FETCH_RETURN_HISTORY_FAILURE: {
      const borrowing = action.payload.borrowing || {};
      const history = borrowing.borrowingHistory || {};
      return state.mergeDeep(history).set('isFetching', false);
    }

    case FETCH_RETURN_HISTORY_REQUEST: {
      return state.set('isFetching', true);
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/borrowing/BorrowingHistoryReducer.js